import { useMemo } from 'react';
import { resolveAssistantEligibility } from '@Containers/Summary/assistantEligibility';
import { resolveSummaryChain } from '@Containers/Summary/summaryContext';

// AR-1.4: the chain lookup is a plain hook computation (not a Redux selector, since breadcrumbs
// live outside the store — AR-1.0), shared by every consumer that needs the composite chain key.
export const useSummaryChain = (activeBreadcrumb) => useMemo(() => resolveSummaryChain(activeBreadcrumb), [activeBreadcrumb]);

// `assistantEligible` is the sole backend eligibility signal. New derived breadcrumbs carry their
// normalized effective value; the root fallback supports older/session-restored breadcrumbs.
const useSummaryAvailable = ({ activeBreadcrumb }) => {
  const { rootBreadcrumb, chainKey } = useSummaryChain(activeBreadcrumb);

  const isSummaryAvailable = resolveAssistantEligibility(activeBreadcrumb, rootBreadcrumb);

  return {
    isSummaryAvailable,
    chainKey,
    rootBreadcrumb,
  };
};

export default useSummaryAvailable;
